import { PDFViewer } from '@react-pdf/renderer'
import { useLocation } from 'react-router-dom'
import ProductPdfDirectSales from '../../../features/Inventory/PuchaseOrderUI/ManageProduct/ProductPdfDirectSales'

const ViewDirectSales = () => {
    const location = useLocation()
    return (
        <div className=' w-full h-[900px]'>
            <PDFViewer width="100%" height="100%">
                <ProductPdfDirectSales data={location.state.data} />
            </PDFViewer>
        </div>
    )
}


export default ViewDirectSales
